// extracted by css-extract-rspack-plugin
var _1 = "OEp5x_zRTYxu7TJD";
export { _1 as "wrapper" }
